import React, { useState } from 'react';
import { SlideDown } from 'react-slidedown';

import moment from 'moment';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { Requester, Traveler } from 'models/travelDetails';

import { Arrow, Card, Header, Label, PassengerIcon, Row, Title, Value } from './styles';

interface Props {
  requester: Requester;
  travelers?: Traveler[];
}
const PassengerBox = ({ requester, travelers }: Props) => {
  const { t } = useStoreTranslation();

  const [show, setShow] = useState(false);

  const formattedBirthDate = (dateOfBirth: string) => moment.utc(dateOfBirth).format('DD/MM/YYYY') ?? '';

  return (
    <Card>
      <Header onClick={() => setShow(!show)}>
        <Title>
          <PassengerIcon />
          {requester.fullName} {travelers && travelers.length > 1 ? '+ ' + (travelers.length - 1) : ''}
        </Title>
        <Arrow className={show ? 'active' : ''} />
      </Header>
      <SlideDown closed={!show}>
        {travelers &&
          travelers.length > 0 &&
          travelers.map((traveler, index) => (
            <>
              <Row>
                <Label>{t('travelDetails.passenger.name')}</Label>
                <Value>
                  {traveler.firstName} {traveler.lastName}
                </Value>
              </Row>
              <Row>
                <Label>{t('travelDetails.passenger.document')}</Label>
                <Value>{traveler.documentNumber}</Value>
              </Row>
              <Row>
                <Label>{t('travelDetails.passenger.birthDate')}</Label>
                <Value>{formattedBirthDate(traveler.dob)}</Value>
              </Row>
              {traveler.phone && (
                <Row>
                  <Label>{t('travelDetails.passenger.phoneNumber')}</Label>
                  <Value>{traveler.phone}</Value>
                </Row>
              )}
              {traveler.email && (
                <Row>
                  <Label>{t('travelDetails.passenger.email')}</Label>
                  <Value>{traveler.email}</Value>
                </Row>
              )}

              {index < travelers.length - 1 && <hr></hr>}
            </>
          ))}
      </SlideDown>
    </Card>
  );
};

export default PassengerBox;
